// extracted by mini-css-extract-plugin
module.exports = {"form-group":"specificatie-indicatie_form-group__36Foj","form-row":"specificatie-indicatie_form-row__17PGz","percentage_offset":"specificatie-indicatie_percentage_offset__3hH2U"};